var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_vm.currentStep && _vm.currentStep.loading ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm.step !== _vm.RepairEstimateSteps.SELLER ? _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.currentStep.title) + " ")]) : _vm._e(), _vm.currentStep && _vm.currentStep.subtitle ? _c('v-card-subtitle', [_vm._v(" " + _vm._s(_vm.currentStep.subtitle) + " ")]) : _vm._e(), _c('v-card-text', [_c('repair-estimate-create-stepper', {
    ref: "requestRepairEstimateStepper",
    attrs: {
      "sellerCompanyId": _vm.sellerCompanyId,
      "step": _vm.step,
      "hideRefsSelect": true,
      "report": _vm.report
    },
    on: {
      "update:step": function updateStep($event) {
        _vm.step = $event;
      }
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), _c('v-card-actions', [_vm.step !== _vm.RepairEstimateSteps.SELLER ? _c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": function click() {
        return _vm.currentStep.back();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.currentStep.backText) + " ")]) : _vm._e(), _vm.step !== _vm.RepairEstimateSteps.SUCCESS ? _c('v-btn', {
    attrs: {
      "elevation": 0,
      "color": "success",
      "loading": _vm.currentStep.loading,
      "disabled": _vm.currentStep.disabled
    },
    on: {
      "click": function click() {
        return _vm.currentStep.next();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.currentStep.nextText) + " ")]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }